"use client";

import React from "react";
import _isFinite from "lodash/isFinite";

import styled from "styled-components";
import Box from "../Box";
import Text from "../Text";
import Flex from "../Flex";
import InfoTip from "../Tooltip/InfoTip";
import Icon from "../Icon";

const BigNumberContainer = styled(Box).attrs({
  flex: 1,
  py: "m",
  border: "default",
  background: "grayLightest",
  borderRadius: "default",
  textAlign: "center",
  minWidth: "150px",
})``;

type DiffInput = {
  diff: number;
};

const BigNumberDiff = styled(Text).attrs<DiffInput>(props => {
  return {
    font: "ui.smallBold",
    color: props.diff < 0 ? "error" : "success",
  };
})<DiffInput>``;

const BigNumberDiffIcon = styled(Icon).attrs<DiffInput>(props => {
  return {
    iconId: props.diff < 0 ? "navigation.chevron-down" : "navigation.chevron-up",
    fill: props.diff < 0 ? "error" : "success",
    size: "16",
  };
})<DiffInput>``;

type Props = {
  title: string;
  value: string | number;
  diff?: number;
  // Added to allow for custom diff formatting (50MB instead of 50000000)
  formattedDiff?: string;
  tooltip?: string;
};

const BigNumber: React.FC<Props> = ({ title, value, diff, formattedDiff, tooltip }) => {
  const bigNumberDiff = formattedDiff ?? Math.abs(diff).toString();
  return (
    <BigNumberContainer height="100%">
      <Flex alignItems="center" justifyContent="center">
        <Text truncate font="ui.regular" color="grayDarkest">
          {title}
        </Text>
        {tooltip && (
          <InfoTip direction="bottom" fill="grayDarkest">
            {tooltip}
          </InfoTip>
        )}
      </Flex>
      <Text font="ui.pageTitle">{value ?? "-"}</Text>
      {_isFinite(diff) &&
        (diff === 0 ? (
          <Text font="ui.smallBold" color="grayDarkest">
            0
          </Text>
        ) : (
          <Flex justifyContent="center">
            {/* blank iconId to satify type */}
            <BigNumberDiffIcon diff={diff} iconId="" />
            <BigNumberDiff diff={diff}>{bigNumberDiff}</BigNumberDiff>
          </Flex>
        ))}
    </BigNumberContainer>
  );
};

export default BigNumber;
